
  module.exports =
  {

    form:
    {

      _init: function ()
      {

        $('.js-is-vulnerable').not('.js-ignore').change(function ()
        {

          if ($('.js-is-vulnerable[value=1]').is(':checked'))
          {
            $('#vulnerability-wrapper').show()
          }
          else
          {
            $('#vulnerability-wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')
     
      }

    }

  }